import { useState } from 'react';
import styles from './styles/QtySelector.module.css';
import { Minus, Plus } from 'lucide-react';

export const QuantitySelector = ({ value = 1, onChange }) => {
  const handleDecrement = () => {
    if (value > 1) onChange(value - 1);
  };

  const handleIncrement = () => {
    onChange(value + 1);
  };

  const handleChange = (e) => {
    const val = parseInt(e.target.value, 10);
    if (!isNaN(val) && val >= 1) {
      onChange(val);
    } else if (e.target.value === '') {
      onChange('');
    }
  };

  const handleBlur = () => {
    if (!value || value < 1) {
      onChange(1);
    }
  };

  return (
    <div className={styles.qtyWrapper}>
      <button className={styles.qtyBtn} onClick={handleDecrement}>
        <Minus size={16} />
      </button>
      <input type='number' min='1' className={styles.qtyCounter} value={value} onChange={handleChange} onBlur={handleBlur} />
      <button className={styles.qtyBtn} onClick={handleIncrement}>
        <Plus size={16} />
      </button>
    </div>
  );
};
